export default __webpack_public_path__ + "static/media/logo-thaibev.059974ec.svg";